(() => {
  'use strict';
  if (window.__PW9_PDP_STORY_READY__) return;
  window.__PW9_PDP_STORY_READY__ = true;

  const $ = (selector, root = document) => root?.querySelector(selector) || null;
  const $$ = (selector, root = document) => root ? [...root.querySelectorAll(selector)] : [];
  const viewer = $('[data-pw4-story-viewer]');
  if (!viewer) return;

  const state = {
    cards: [],
    index: 0,
    timer: 0,
    slideTimer: 0,
    startedAt: 0,
    duration: 6200,
    mediaIndex: 0,
    trigger: null
  };

  const benefitCopy = {
    DOKU: 'Ürünün gerçek dokusunu ve ciltteki yayılımını yakından izle.',
    UYGULAMA: 'Doğru miktarı ve ürünü rutine nasıl yerleştireceğini gör.',
    FORMÜL: 'Formülün hissini, bitişini ve kullanım karakterini keşfet.',
    'RİTÜEL': 'Ürünü diğer adımlarla doğru sırada kullanmanın akışını izle.',
    SONUÇ: 'Düzenli kullanımın hedeflediği görünümü ve bitişi keşfet.'
  };

  const clearTimers = () => {
    window.clearInterval(state.timer);
    window.clearInterval(state.slideTimer);
    state.timer = 0;
    state.slideTimer = 0;
  };

  const unique = values => [...new Set(values.filter(Boolean))];

  const ensureProductPanel = () => {
    const panel = $('[data-pw4-story-product]', viewer);
    if (!panel || panel.dataset.pw9PanelReady === 'true') return panel;
    panel.dataset.pw9PanelReady = 'true';

    const copy = $('.pw4-story-viewer__copy', panel);
    const title = $('[data-pw4-story-title]', panel);
    if (copy && title && !$('[data-pw5-story-benefit]', panel)) {
      const benefit = document.createElement('p');
      benefit.className = 'pw4-story-viewer__benefit';
      benefit.dataset.pw5StoryBenefit = '';
      title.insertAdjacentElement('afterend', benefit);
    }

    const button = $('button[type="submit"]', panel);
    if (button) {
      button.classList.add('pw4-story-viewer__add');
      if (!$('span', button)) {
        button.innerHTML = '<span>SEPETE EKLE</span><strong data-pw5-story-button-price></strong><i aria-hidden="true">↗</i>';
      } else if (!$('[data-pw5-story-button-price]', button)) {
        const price = document.createElement('strong');
        price.dataset.pw5StoryButtonPrice = '';
        button.append(price);
      }
    }
    return panel;
  };

  const readCard = card => {
    const directVideo = card.dataset.pw4StoryVideo || '';
    const video = $('video', card);
    const source = $('video source', card);
    const videoSrc = directVideo || source?.src || video?.currentSrc || video?.src || '';
    const images = unique($$('img', card).map(image => image.currentSrc || image.src));
    const media = videoSrc
      ? [{ type: 'video', src: videoSrc, poster: video?.poster || images[0] || '' }]
      : images.map(src => ({ type: 'image', src }));

    const caption = String(card.dataset.pw4ProductCaption || 'DOKU').toLocaleUpperCase('tr-TR');
    return {
      title: card.dataset.pw4ProductTitle || '',
      caption,
      benefit: benefitCopy[caption] || 'Ürünün gerçek dokusunu, uygulamasını ve ritüeldeki yerini keşfet.',
      price: card.dataset.pw4ProductPrice || '',
      url: card.dataset.pw4ProductUrl || '',
      variant: card.dataset.pw4ProductVariant || '',
      available: card.dataset.pw4ProductAvailable !== 'false',
      productImage: card.dataset.pw4ProductImage || images[0] || '',
      media
    };
  };

  const buildProgress = () => {
    const host = $('[data-pw4-story-progress]', viewer);
    if (!host) return;
    host.innerHTML = state.cards.map((_, index) =>
      `<i><b data-pw9-story-progress="${index}"></b></i>`
    ).join('');
  };

  const setProgress = ratio => {
    $$('[data-pw9-story-progress]', viewer).forEach((bar, progressIndex) => {
      const value = progressIndex < state.index ? 1 : progressIndex > state.index
        ? 0
        : Math.max(0, Math.min(1, ratio));
      bar.style.transform = `scaleX(${value})`;
    });
  };

  const hydrateProduct = data => {
    const panel = ensureProductPanel();
    if (!panel) return;

    const image = $('[data-pw4-story-product-image]', panel);
    const title = $('[data-pw4-story-title]', panel);
    const caption = $('[data-pw4-story-caption]', panel);
    const benefit = $('[data-pw5-story-benefit]', panel);
    const price = $('[data-pw4-story-price]', panel);
    const buttonPrice = $('[data-pw5-story-button-price]', panel);
    const input = $('[data-pw4-story-variant]', panel);
    const button = $('button[type="submit"]', panel);

    if (image) {
      image.src = data.productImage || '';
      image.alt = data.title || '';
    }
    if (title) title.textContent = data.title;
    if (caption) caption.textContent = `${data.caption} • GERÇEK RUTİN`;
    if (benefit) benefit.textContent = data.benefit;
    if (price) price.textContent = data.price;
    if (buttonPrice) buttonPrice.textContent = data.price;
    if (input) input.value = data.variant;

    $$('[data-pw4-story-link]', panel).forEach(link => {
      link.href = data.url || '#';
      link.hidden = !data.url;
    });

    if (button) {
      button.disabled = !data.variant || !data.available;
      button.setAttribute('aria-label', data.available ? `${data.title} sepete ekle` : `${data.title} tükendi`);
      const label = $('span', button);
      if (label) label.textContent = data.available ? 'SEPETE EKLE' : 'TÜKENDİ';
    }
    panel.hidden = !data.title;
  };

  const renderMedia = data => {
    const host = $('[data-pw4-story-media]', viewer);
    if (!host) return;
    host.replaceChildren();
    host.classList.remove('is-muted');

    const media = data.media.length
      ? data.media
      : data.productImage
        ? [{ type: 'image', src: data.productImage }]
        : [];
    if (!media.length) return;

    state.mediaIndex = 0;
    if (media[0].type === 'video') {
      const item = media[0];
      const video = document.createElement('video');
      video.src = item.src;
      if (item.poster) video.poster = item.poster;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'auto';
      video.muted = true;
      video.setAttribute('aria-label', `${data.title} ürün videosu`);
      host.append(video);
      host.classList.add('is-muted');
      state.duration = 10000;

      video.addEventListener('loadedmetadata', () => {
        if (Number.isFinite(video.duration) && video.duration > 0) {
          state.duration = Math.max(3800, video.duration * 1000);
        }
        state.startedAt = performance.now();
      }, { once: true });
      video.addEventListener('ended', () => nextStory(1));
      video.addEventListener('click', () => {
        video.muted = !video.muted;
        host.classList.toggle('is-muted', video.muted);
      });
      video.play().catch(() => {});
      return;
    }

    const showImage = () => {
      const image = document.createElement('img');
      image.src = media[state.mediaIndex].src;
      image.alt = data.title || '';
      image.decoding = 'async';
      host.replaceChildren(image);
    };
    showImage();
    state.duration = Math.max(5600, media.length * 1750);
    if (media.length > 1) {
      state.slideTimer = window.setInterval(() => {
        state.mediaIndex = (state.mediaIndex + 1) % media.length;
        showImage();
      }, state.duration / media.length);
    }
  };

  const startProgress = () => {
    state.startedAt = performance.now();
    state.timer = window.setInterval(() => {
      const ratio = Math.min(1, (performance.now() - state.startedAt) / state.duration);
      setProgress(ratio);
      if (ratio >= 1) nextStory(1);
    }, 70);
  };

  const render = () => {
    if (!state.cards.length) return;
    clearTimers();
    state.index = (state.index + state.cards.length) % state.cards.length;
    const data = readCard(state.cards[state.index]);
    const count = $('[data-pw4-story-count]', viewer);
    if (count) count.textContent = `${state.index + 1} / ${state.cards.length}`;
    setProgress(0);
    hydrateProduct(data);
    renderMedia(data);
    startProgress();
  };

  function closeViewer() {
    clearTimers();
    $('[data-pw4-story-media]', viewer)?.replaceChildren();
    viewer.removeAttribute('aria-busy');
    if (viewer.open && typeof viewer.close === 'function') {
      viewer.close();
    } else {
      viewer.removeAttribute('open');
    }
    document.body.classList.remove('is-locked');
    state.trigger?.classList.remove('is-opening');
    state.trigger?.focus?.({ preventScroll: true });
  }

  function nextStory(direction) {
    if (!viewer.hasAttribute('open') || !state.cards.length) return;
    const next = state.index + direction;
    if (next >= state.cards.length) {
      closeViewer();
      return;
    }
    state.index = next < 0 ? state.cards.length - 1 : next;
    render();
  }

  const openViewer = trigger => {
    const collection = trigger.closest('[data-pw4-story-collection]');
    if (!collection) return;

    state.cards = $$('[data-pw4-story-card]', collection);
    if (!state.cards.length) return;

    const card = trigger.closest('[data-pw4-story-card]') || trigger;
    const actualIndex = state.cards.indexOf(card);
    state.index = actualIndex >= 0 ? actualIndex : 0;
    state.trigger = trigger;
    trigger.classList.add('is-opening');

    buildProgress();
    ensureProductPanel();
    viewer.setAttribute('aria-busy', 'true');

    if (!viewer.open) {
      try {
        viewer.showModal();
      } catch {
        viewer.setAttribute('open', '');
      }
    }

    document.body.classList.add('is-locked');
    render();
    viewer.removeAttribute('aria-busy');
    requestAnimationFrame(() => $('[data-pw4-story-close]', viewer)?.focus({ preventScroll: true }));
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-pw4-story-open]');
    if (!trigger || event.target.closest('form')) return;
    event.preventDefault();
    event.stopPropagation();
    openViewer(trigger);
  }, true);

  $('[data-pw4-story-close]', viewer)?.addEventListener('click', closeViewer);
  $('[data-pw4-story-prev]', viewer)?.addEventListener('click', () => nextStory(-1));
  $('[data-pw4-story-next]', viewer)?.addEventListener('click', () => nextStory(1));

  viewer.addEventListener('click', event => {
    if (event.target === viewer) closeViewer();
  });
  viewer.addEventListener('cancel', event => {
    event.preventDefault();
    closeViewer();
  });
  viewer.addEventListener('submit', event => {
    if (event.target.matches('[data-pw4-story-form]')) {
      window.setTimeout(closeViewer, 620);
    }
  });

  document.addEventListener('keydown', event => {
    if (!viewer.hasAttribute('open')) return;
    if (event.key === 'ArrowLeft') nextStory(-1);
    if (event.key === 'ArrowRight') nextStory(1);
  });

  let startX = null;
  let startY = null;
  viewer.addEventListener('pointerdown', event => {
    if (event.target.closest('a,button,form,video')) return;
    startX = event.clientX;
    startY = event.clientY;
  });
  viewer.addEventListener('pointerup', event => {
    if (startX === null) return;
    const dx = event.clientX - startX;
    const dy = event.clientY - startY;
    startX = null;
    startY = null;
    if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) {
      nextStory(dx < 0 ? 1 : -1);
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (!viewer.hasAttribute('open')) return;
    if (document.hidden) clearTimers();
    else render();
  });

  ensureProductPanel();
})();
